import React from 'react';

import "./sidebar.scss";

export default function Sidebar() {
  return (
    <section className="sidebar">      
      <ul className="sidebar__links">
        <li className="active">
          <a href="#"><i className="fas fa-home"></i> Home</a>
        </li>
        <li>
          <a href="#"><i className="fas fa-hand-rock"></i> Champions</a>
        </li>
        <li>
          <a href="#"><i className="fas fa-chart-line"></i> Stats</a>
        </li>
        <li>
          <a href="#"><i className="fas fa-trophy"></i> Leaderboards</a>
        </li>
        <li>
          <a href="#"><i className="fab fa-chrome"></i> Extension</a>
        </li>
      </ul>
    </section>
  )
}
